export default __webpack_public_path__ + "img/497638e5e7810861714b860187684e81.png";